export const CLASS_SNACKBAR = 'snackbar';
